/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import './TablePage.less';
import ButtonML from '@/components/button_ml/ButtonML';
import { useDispatch, useSelector } from 'dva';
import React, { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import Loading from '@/components/Loading';
import SelectML from '@/components/select_ml/SelectML';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import { toOption } from '@/utils/comUtil.js';
import {
  outputTypeMap,
  conditionTypeMap,
  conditionMathMap,
  conditionTypeTwoMap,
  logicalOperatorMap,
} from '@/constants.js';
import { useTrigger } from '@/utils/comHook.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import Cascader from '@/containers/cascader_ml/cascader_package_ml/CascaderPackage';
// import { resetSingleAddForm } from '../../../../../utils/breUtils';

const RuleTabel = (props) => {
  const dispatch = useDispatch();
  const { name, fetchData, isSing, form, editable } = props || {};
  //控制弹框的开关
  const trigger = useTrigger();
  const deleteTrigger = useTrigger();

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['condition/getRuleList'];
  const delLoading =
    loadingEffect.effects['condition/deleteRuleList'] ||
    loadingEffect.effects['condition/deleteMulRuleList'];

  const data = useSelector((state) => state.condition.getRuleList);
  const { regularExpressions, relationNo, combineRelations } =
    (data && data.data) || {};
  //对初始值进行平级结构
  (combineRelations || []).forEach((item) => {
    const { firstCondition, secondCondition } = item || {};
    for (let key in firstCondition) {
      item['first_' + key] = firstCondition[key];
    }
    for (let key in secondCondition) {
      item['second_' + key] = secondCondition[key];
    }
  });
  let ruleList = isSing ? regularExpressions : combineRelations;
  // const [delLoading, setDelLoading] = useState(false);
  const [tabelD, setTabelD] = useState([]);
  const [addIndex, setAddIndex] = useState(1);
  const [cascaderData, setCascaderData] = useState({});
  const [addOptions, setAddOptions] = useState([]);

  useEffect(() => {
    setTabelD(ruleList ? ruleList : []);
  }, [data]);
  //删除规则
  const deleteRuleChange = (values) => {
    if (isSing) {
      const { id = '' } = values || {};
      if (String(id).indexOf('null') !== -1) {
        const s = tabelD.filter((item) => item.id !== id);
        setTabelD(s);
        setAddIndex(addIndex - 1);
      } else {
        // setDelLoading(true);
        dispatch({
          type: 'condition/deleteRuleList',
          payload: {
            values: {
              ...values,
            },
          },
          callback: (d) => {
            // setDelLoading(false);
            if (d?.code) {
              message.warning(d.message);
            } else {
              message.success('删除成功');
              fetchData && fetchData();
            }
          },
        });
      }
    } else {
      const { relationId = '' } = values || {};
      if (String(relationId).indexOf('null') !== -1) {
        const s = tabelD.filter((item) => item.relationId !== relationId);
        setTabelD(s);
        setAddIndex(addIndex - 1);
      } else {
        // setDelLoading(true);
        dispatch({
          type: 'condition/deleteMulRuleList',
          payload: {
            values: {
              ...values,
            },
          },
          callback: (d) => {
            // setDelLoading(false);
            if (d?.code) {
              message.error(d?.message);
            } else {
              message.success('删除成功');
            }
            fetchData();
          },
        });
      }
    }
  };
  // let i = 0;
  const addRuleList = () => {
    let s = ruleList ? ruleList : []; //初始时如果初始化每次都认为指针改变
    if (addIndex > 1) {
      message.warning('请点击保存，一条一条填写'); //多条一起填写增加删除会有每次清空的bug
      return;
    }
    let add = [];
    if (isSing) {
      //单个是利用null+i区分
      for (let j = 0; j < addIndex; j++) {
        add.push({ id: 'null' + j });
      }
      setTabelD([...s, ...add]);
      setAddIndex(addIndex + 1);
    } else {
      const lastRelationNo =
        tabelD[tabelD.length - 1] && tabelD[tabelD.length - 1].relationNo;
      //多个是具有唯一的relationNo
      for (let k = 0; k < addIndex; k++) {
        add.push({
          relationNo: lastRelationNo ? lastRelationNo + k + 1 : 1, //判断如果为刚开始时候新建为1
          relationId: 'null' + k,
        });
      }
      setTabelD([...s, ...add]);
      setAddIndex(addIndex + 1);
    }
  };

  //动态option组别1，2
  const groupOption = (num) => {
    const idArrs = (tabelD || []).map((item) => item.relationNo);
    let option = {};
    for (let i = 0; i < idArrs.length; i++) {
      if (idArrs[i] < num) {
        option[idArrs[i]] = '组别' + idArrs[i];
      }
    }
    return option;
  };
  //改变数组是时候更改是否可以选中状态(更改请求到的数据)
  const onSelectType = (val, record, i) => {
    let obj = {};
    obj['condition-' + record.id] = undefined;
    obj['condition@-' + record.id] = undefined;
    if (i === 'first') {
      obj['first_condition-' + record.relationId] = undefined;
      obj['first_condition@-' + record.relationId] = undefined;
      obj['first_condition&-' + record.relationId] = undefined;
    }
    if (i === 'second') {
      obj['second_condition-' + record.relationId] = undefined;
      obj['second_condition@-' + record.relationId] = undefined;
      obj['second_condition&-' + record.relationId] = undefined;
    }

    form.setFieldsValue({
      ...obj,
    });
    let tabelDCopy = JSON.parse(JSON.stringify(tabelD));
    (tabelDCopy || []).forEach((item, index) => {
      if (val === 'COMBINE') {
        if (record.relationId === tabelDCopy[0].relationId && index === 0) {
          message.warning('第一组不能选择组别');
          // form.resetFields();
          return;
        }
      }
      if (item.relationId === record.relationId && i === 'first') {
        item.first_conditionType = val;
        item.first_condition = undefined;
        item.first_conditionName = undefined;
      } else if (item.relationId === record.relationId && i === 'second') {
        item.second_conditionType = val;
        item.second_condition = undefined;
        item.second_conditionName = undefined;
      } else if (item.id === record.id && !i) {
        //单个的条件类型更改
        item.conditionType = val;
        item.condition = undefined;
      }
    });
    setTabelD(tabelDCopy);
  };

  //常亮变量
  const onSelectChange = async (val, record, i) => {
    let tabelDCopy = JSON.parse(JSON.stringify(tabelD));

    (tabelDCopy || []).forEach((item, index) => {
      if (val === 'COMBINE') {
        if (record.relationId === tabelDCopy[0].relationId && index === 0) {
          message.warning('第一组不能选择组别');
          // form.resetFields();
          return;
        }
      }
      if (item.relationId === record.relationId && i === 'first') {
        item['first_valueType'] = val;
        item.first_value = undefined;
      } else if (item.relationId === record.relationId && i === 'second') {
        item['second_valueType'] = val;
        item.second_value = undefined;
      } else if (item.id === record.id && !i) {
        //单个的条件类型更改
        item.valueType = val;
        item.value = undefined;
      }
    });
    await setTabelD(tabelDCopy);

    let obj = {};
    obj['value-' + record.id] = undefined;
    obj['value@-' + record.id] = undefined;
    if (i === 'first') {
      obj['first_value-' + record.relationId] = undefined;
      obj['first_value@-' + record.relationId] = undefined;
      obj['first_value&-' + record.relationId] = undefined;
    }
    if (i === 'second') {
      obj['second_value-' + record.relationId] = undefined;
      obj['second_value@-' + record.relationId] = undefined;
      obj['second_value&-' + record.relationId] = undefined;
    }
    form.setFieldsValue({
      ...obj,
    });
  };

  // 级联更改时候保存之前选择的级联值dataSource
  const handleCascaderChange = (val, record, i) => {
    tabelD.forEach((item) => {
      if (item.id === record.id && i === 'sing-condition') {
        item['condition'] = val[1];
      }
      if (item.id === record.id && i === 'sing-value') {
        item['value'] = val[1];
      }
      if (item.id === record.id && i === 'first_condition') {
        item['first_condition'] = val[1];
      }
    });
  };

  const fetchTabelData = useCallback(() => {
    let s = ruleList ? ruleList : []; //刚开始接口没有请求到请求ruleList不是数组会报不能使用扩展运算符错误
    setTabelD([...s]);
    setAddIndex(1); //避免每次增加累计增加虚拟List
  }, [ruleList]);
  useEffect(() => {
    fetchTabelData();
  }, [fetchTabelData]);

  useEffect(() => {
    //为了单多按钮切换时清空单多条件的列表
    form.resetFields();
    fetchTabelData();
  }, [isSing]);

  // 获取级联下拉数据
  const fetchPackageData = useCallback(() => {
    dispatch({
      type: 'bre/getAllPackages',
      payload: {},
      callback: (res) => {
        let result = [];
        let cascaderDataUnuse = {};
        res &&
          res.length > 0 &&
          res.forEach((item) => {
            let child = [];
            item.fields &&
              item.fields.forEach((item2) => {
                child.push({
                  value: item2.id,
                  label: item2.fieldName,
                });
                cascaderDataUnuse[item2.id] = [item.fieldPackageId, item2.id];
              });
            result.push({
              value: item.fieldPackageId,
              label: item.fieldPackageName,
              children: child,
            });
          });
        setCascaderData(cascaderDataUnuse);
        setAddOptions(result);
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchPackageData();
  }, [fetchPackageData]);

  // 对新增的并未保存的dataSouece进行清空
  useEffect(() => {
    let formResetObj = form.getFieldsValue();
    let newResetObj = {};
    for (let key in formResetObj) {
      if (key.includes('null')) {
        newResetObj[key] = undefined;
      }
    }
    form.setFieldsValue({
      ...newResetObj,
    });
  }, [tabelD.length]);

  useEffect(() => {
    let obj = {};
    tabelD.forEach((item) => {
      for (const key in cascaderData) {
        if (item.condition === key) {
          obj['condition-' + item.id] = cascaderData[key];
        }
        if (item.valueType !== 'CONSTANT' && item.value === key) {
          obj['value-' + item.id] = cascaderData[key];
        }
        if (item.first_condition === key) {
          obj['condition-' + item.relationId] = cascaderData[key];
          obj['value-' + item.relationId] = cascaderData[key];
          obj['first_condition-' + item.relationId] = cascaderData[key];
          // 默认为数组的话，反显所取得数组的第二个
          if (item.first_conditionType === 'COMBINE') {
            obj['first_condition-' + item.relationId] =
              obj['first_condition-' + item.relationId][1];
          }
        }
        if (item.first_value === key) {
          obj['first_value-' + item.relationId] = cascaderData[key];
        }
        if (item.second_condition === key) {
          obj['second_condition-' + item.relationId] = cascaderData[key];
          // 默认为数组的话，反显所取得数组的第二个
          if (item.second_conditionType === 'COMBINE') {
            obj['second_condition-' + item.relationId] =
              obj['second_condition-' + item.relationId][1];
          }
        }
        if (item.second_value === key) {
          obj['second_value-' + item.relationId] = cascaderData[key];
        }
      }
    });

    form.setFieldsValue({
      ...obj,
    });
  }, [cascaderData, form, tabelD]);
  const columns = isSing
    ? [
        {
          title: '组别',
          dataIndex: 'relationNo',
          key: 'relationNo',
          width: 50,
          render: () => {
            return <span>{relationNo}</span>;
          },
        },
        {
          title: '条件类型',
          dataIndex: 'conditionType',
          key: 'conditionType',
          width: 200,
          render: (text, record) => {
            return (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={['no_label']}
                placeVal="请选择"
                name={'conditionType-' + record.id}
                value={text}
                option={toOption(conditionTypeMap)}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                onSelect={(val) => onSelectType(val, record)}
              />
            );
          },
        },
        {
          title: '条件',
          dataIndex: 'condition',
          key: 'condition',
          width: 200,
          render: (text, record) => {
            let opt = {};
            opt[record.condition] = record.conditionName;
            return record.conditionType === 'FIELD' ? (
              <div className={styles.seled_filter}>
                <Cascader
                  height="37px"
                  options={addOptions}
                  allowClear={true}
                  placeVal={'请输入'}
                  name={'condition-' + record.id}
                  value={cascaderData[record.condition]}
                  form={form}
                  className={['mt']}
                  require={[
                    {
                      required: true,
                      message: '请选择规则包状态',
                    },
                  ]}
                  onChange={(val) =>
                    handleCascaderChange(val, record, 'sing-condition')
                  }
                  displayRender={(label) => {
                    return String(editable) === 'false'
                      ? label && label[1]
                      : label.join('/');
                  }}
                />
              </div>
            ) : (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                placeVal="请输入值"
                className="no_label"
                name={'condition@-' + record.id}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                // allowClear={true}
              />
            );
          },
        },
        {
          title: '运算符',
          dataIndex: 'operator',
          key: 'operator',
          width: 200,
          render: (text, record) => {
            return (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={['no_label']}
                placeVal="请选择"
                name={'operator-' + record.id}
                // allowClear={true}
                option={toOption(conditionMathMap)}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
              />
            );
          },
        },
        {
          title: '值类型',
          dataIndex: 'valueType',
          key: 'valueType',
          width: 200,
          render: (text, record) => {
            return (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={['no_label']}
                placeVal="请选择"
                name={'valueType-' + record.id}
                // allowClear={true}
                option={toOption(outputTypeMap)}
                value={text}
                onSelect={(val) => onSelectChange(val, record)}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
              />
            );
          },
        },
        {
          title: '值',
          dataIndex: 'value',
          key: 'value',
          width: 200,
          render: (text, record) => {
            return record.valueType === 'VARIABLE' ? (
              <Cascader
                height="37px"
                options={addOptions}
                allowClear={true}
                placeVal={'请输入'}
                name={'value-' + record.id}
                value={cascaderData[record.value]}
                form={form}
                className={['mt']}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                onChange={(val) =>
                  handleCascaderChange(val, record, 'sing-value')
                }
                displayRender={(label) => {
                  return String(editable) === 'false'
                    ? label && label[1]
                    : label.join('/');
                }}
              />
            ) : (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className="no_label"
                name={'value@-' + record.id}
                value={record.value}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                // allowClear={true}
              />
            );
          },
        },
        {
          title: '操作',
          render: (record) => {
            return (
              <div className={styles.handle_btn}>
                <ModalConfirmML
                  title="是否确认删除?"
                  handleOk={() => deleteRuleChange(record)}
                  handleCancel={deleteTrigger.close}
                  visible={deleteTrigger.visible}
                  value="删除"
                  icon={<ExclamationCircleOutlined />}
                  disabled={String(editable) === 'false'}
                />
              </div>
            );
          },
          width: 100,
        },
      ]
    : [
        {
          title: '组别',
          dataIndex: 'relationNo',
          key: 'relationNo',
          width: 50,
          render: (text) => {
            return <span>{text}</span>;
          },
        },
        {
          title: '条件类型',
          dataIndex: 'first_conditionType',
          key: 'first_conditionType',
          // key: 'firstCondition.conditionType', ？？为什么层级直接取不出来
          width: 200,
          render: (text, record) => {
            let opt = toOption(conditionTypeTwoMap) || [];
            if (record.relationId === tabelD[0].relationId) {
              opt[2]['disabled'] = true;
            }
            return (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={['no_label']}
                placeVal="请选择"
                name={'first_conditionType-' + record.relationId}
                value={text}
                option={opt}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                onSelect={(val) => onSelectType(val, record, 'first')}
              />
            );
          },
        },
        {
          title: '左条件',
          dataIndex: 'first_condition',
          key: 'first_condition',
          width: 200,
          render: (text, record) => {
            let opt = {};
            opt[record.first_condition] = record.first_conditionName;
            return record.first_conditionType !== 'EXTERNAL_INPUT' ? (
              record.first_conditionType === 'COMBINE' ? (
                <SelectML
                  height="37px"
                  labelwidth="130px"
                  inputWidth="180px"
                  placeVal="请选择"
                  name={'first_condition&-' + record.relationId}
                  // allowClear={true}
                  className={['no_label']}
                  option={toOption(groupOption(record.relationNo))}
                  value={
                    record.first_conditionName
                      ? '组别' + record.first_conditionName
                      : ''
                  }
                  require={[
                    {
                      required: true,
                      message: '请选择规则包状态',
                    },
                  ]}
                  disabled={!record.first_conditionType}
                />
              ) : (
                <div className={styles.seled_filter}>
                  <Cascader
                    height="37px"
                    options={addOptions}
                    allowClear={true}
                    placeVal={'请输入'}
                    name={'first_condition-' + record.relationId}
                    value={cascaderData[record.first_condition]}
                    form={form}
                    className={['mt']}
                    require={[
                      {
                        required: true,
                        message: '请选择规则包状态',
                      },
                    ]}
                    onChange={(val) =>
                      handleCascaderChange(val, record, 'first_condition')
                    }
                    displayRender={(label) => {
                      return String(editable) === 'false'
                        ? label && label[1]
                        : label.join('/');
                    }}
                  />
                </div>
              )
            ) : (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                placeVal="请输入值"
                className="no_label"
                name={'first_condition@-' + record.relationId}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                // allowClear={true}
              />
            );
          },
        },
        {
          title: '运算符',
          dataIndex: 'first_relationOperator',
          key: 'first_relationOperator',
          width: 200,
          render: (text, record) => {
            return record.first_conditionType === 'COMBINE' ? (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                value={'等于'}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            ) : (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={[
                  'no_label',
                  record.first_conditionType === 'COMBINE' ? 'dis-grey' : '',
                ]}
                placeVal="请选择"
                name={'first_relationOperator-' + record.relationId}
                option={toOption(conditionMathMap)}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            );
          },
        },
        {
          title: '值类型',
          dataIndex: 'first_valueType',
          key: 'first_valueType',
          width: 200,
          render: (text, record) => {
            return record.first_conditionType === 'COMBINE' ? (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                value={'常量'}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            ) : (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={[
                  'no_label',
                  record.first_conditionType === 'COMBINE' ? 'dis-grey' : '',
                ]}
                placeVal="请选择"
                name={'first_valueType-' + record.relationId}
                option={toOption(outputTypeMap)}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
                onSelect={(val) => onSelectChange(val, record, 'first')}
              />
            );
          },
        },
        {
          title: '值',
          dataIndex: 'first_value',
          key: 'first_value',
          width: 200,
          render: (text, record) => {
            return record.first_conditionType === 'COMBINE' ? (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                value={'TRUE'}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            ) : record.first_valueType === 'VARIABLE' ? (
              <Cascader
                height="37px"
                options={addOptions}
                allowClear={true}
                placeVal={'请输入'}
                name={'first_value-' + record.relationId}
                value={cascaderData[record.first_value]}
                form={form}
                className={['mt']}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                displayRender={(label) => {
                  return String(editable) === 'false'
                    ? label && label[1]
                    : label.join('/');
                }}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            ) : (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                name={'first_value@-' + record.relationId}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            );
          },
        },
        {
          title: '逻辑运算符',
          dataIndex: 'logicalOperator',
          key: 'logicalOperator',
          width: 200,
          render: (text, record) => {
            return (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={['no_label']}
                placeVal="请选择"
                name={'logicalOperator-' + record.relationId}
                value={text}
                option={toOption(logicalOperatorMap)}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
              />
            );
          },
        },
        {
          title: '条件类型',
          dataIndex: 'second_conditionType',
          key: 'second_conditionType',
          width: 200,
          render: (text, record) => {
            let opt = toOption(conditionTypeTwoMap) || [];
            if (record.relationId === tabelD[0].relationId) {
              opt[2]['disabled'] = true;
            }
            return (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={['no_label']}
                placeVal="请选择"
                name={'second_conditionType-' + record.relationId}
                value={text}
                option={opt}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                onSelect={(val) => onSelectType(val, record, 'second')}
              />
            );
          },
        },
        {
          title: '右条件',
          dataIndex: 'second_condition',
          key: 'second_condition',
          width: 200,
          render: (text, record) => {
            let opt = {};
            opt[record.second_condition] = record.second_conditionName;
            return record.second_conditionType !== 'EXTERNAL_INPUT' ? (
              record.second_conditionType === 'COMBINE' ? (
                <SelectML
                  height="37px"
                  labelwidth="130px"
                  inputWidth="180px"
                  placeVal="请选择"
                  name={'second_condition&-' + record.relationId}
                  // allowClear={true}
                  className={['no_label']}
                  option={toOption(groupOption(record.relationNo))}
                  value={
                    record.second_conditionName
                      ? '组别' + record.second_conditionName
                      : ''
                  }
                  require={[
                    {
                      required: true,
                      message: '请选择规则包状态',
                    },
                  ]}
                  disabled={!record.second_conditionType}
                />
              ) : (
                <div className={styles.seled_filter}>
                  <Cascader
                    height="37px"
                    options={addOptions}
                    allowClear={true}
                    placeVal={'请输入'}
                    name={'second_condition-' + record.relationId}
                    value={cascaderData[record.second_condition]}
                    form={form}
                    className={['mt']}
                    require={[
                      {
                        required: true,
                        message: '请选择规则包状态',
                      },
                    ]}
                    displayRender={(label) => {
                      return String(editable) === 'false'
                        ? label && label[1]
                        : label.join('/');
                    }}
                  />
                </div>
              )
            ) : (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className="no_label"
                name={'second_condition@-' + record.relationId}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
              />
            );
          },
        },
        {
          title: '运算符',
          dataIndex: 'second_relationOperator',
          key: 'second_relationOperator',
          width: 200,
          render: (text, record) => {
            return record.second_conditionType === 'COMBINE' ? (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                value={'等于'}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            ) : (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={[
                  'no_label',
                  record.second_conditionType === 'COMBINE' ? 'dis-grey' : '',
                ]}
                placeVal="请选择"
                name={'second_relationOperator-' + record.relationId}
                // allowClear={true}
                option={toOption(conditionMathMap)}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                disabled={
                  record.second_conditionType === 'COMBINE' ||
                  !record.second_conditionType
                }
              />
            );
          },
        },
        {
          title: '值类型',
          dataIndex: 'second_valueType',
          key: 'second_valueType',
          width: 200,
          render: (text, record) => {
            return record.second_conditionType === 'COMBINE' ? (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                value={'常量'}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            ) : (
              <SelectML
                height="37px"
                labelwidth="130px"
                inputWidth="180px"
                className={[
                  'no_label',
                  record.second_conditionType === 'COMBINE' ? 'dis-grey' : '',
                ]}
                placeVal="请选择"
                name={'second_valueType-' + record.relationId}
                // allowClear={true}
                option={toOption(outputTypeMap)}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                disabled={
                  record.second_conditionType === 'COMBINE' ||
                  !record.second_conditionType
                }
                onSelect={(val) => onSelectChange(val, record, 'second')}
              />
            );
          },
        },
        {
          title: '值',
          dataIndex: 'second_value',
          key: 'second_value',
          width: 200,
          render: (text, record) => {
            return record.second_conditionType === 'COMBINE' ? (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                value={'TRUE'}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.first_conditionType === 'COMBINE' ||
                  !record.first_conditionType
                }
              />
            ) : record.second_valueType === 'VARIABLE' ? (
              <Cascader
                height="37px"
                options={addOptions}
                allowClear={true}
                placeVal={'请输入'}
                name={'second_value-' + record.relationId}
                value={cascaderData[record.second_value]}
                form={form}
                className={['mt']}
                require={[
                  {
                    required: true,
                    message: '请选择规则包状态',
                  },
                ]}
                displayRender={(label) => {
                  return String(editable) === 'false'
                    ? label && label[1]
                    : label.join('/');
                }}
              />
            ) : (
              <SingInputML
                height="37px"
                labelwidth="0px"
                inputWidth="100px"
                // labelVal="规则包名"
                placeVal="请输入值"
                className={['no_label', 'dis-grey']}
                name={'second_value@-' + record.relationId}
                value={text}
                require={[
                  {
                    required: true,
                    message: '请输入值',
                  },
                ]}
                disabled={
                  record.second_conditionType === 'COMBINE' ||
                  !record.second_conditionType
                }
                // allowClear={true}
              />
            );
          },
        },
        {
          title: '操作',
          render: (record) => {
            return (
              <div className={styles.handle_btn}>
                <ModalConfirmML
                  title="是否确认删除?"
                  handleOk={() => deleteRuleChange(record)}
                  handleCancel={deleteTrigger.close}
                  visible={deleteTrigger.visible}
                  value="删除"
                  icon={<ExclamationCircleOutlined />}
                  disabled={String(editable) === 'false'}
                />
              </div>
            );
          },
          width: 100,
        },
      ];
  return (
    <Loading loading={delLoading}>
      <DataTable
        // bordered={true}
        className="demo-test"
        style={{ border: '1px solid #edf0f0' }}
        columns={columns}
        rowSelection={false}
        scroll={{
          x: 1547,
          y: 'calc(50vh - 140px - 3rem)',
        }}
        dataSource={tabelD}
        loading={loading}
        title={() => (
          <div className="rule_name">
            <span>规则名称</span>
            {name}
          </div>
        )}
        footer={() => (
          <ButtonML
            size="large"
            value="添加输入组"
            htmlType="submit"
            fontsize="16px"
            onClick={() => addRuleList()}
            disabled={String(editable) === 'false'}
          />
        )}
      />
    </Loading>
  );
};
export default RuleTabel;
